"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSsoRouter = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
function useSsoRouter() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.ssoRouterKey);
}
exports.useSsoRouter = useSsoRouter;
//# sourceMappingURL=use-api.js.map